/* eslint-disable import/prefer-default-export */
import toastrError from 'src/helpers/toastr/toastrError';
import communicate from 'src/api/communicate';

export const REQUEST = 'LOAD_MOT_REQUEST';
export const SUCCESS = 'LOAD_MOT_SUCCESS';
export const FAIL = 'LOAD_MOT_FAIL';
export const OPTIONS_SUCCESS = 'LOAD_MOT_OPTIONS_SUCCESS';

const loadMotRequest = () => ({ type: REQUEST });

const loadMotFail = (manufacturingOrderType) => ({ type: FAIL, manufacturingOrderType });

const loadMotOptionsSuccess = (motOptions) => ({ type: OPTIONS_SUCCESS, motOptions });

function reformatMotForOptionsMenu(data) {
  return data.map((mot) => ({
    value: mot.Id.toString(),
    label: mot.Name
  }));
}

export const loadMot = () => (dispatch) => {
  dispatch(loadMotRequest());
  return communicate({ url: 'ManufacturingOrderTypes' }).then((response) => {
    // dispatch(loadMotSuccess(response.data.Data));  recomment if needed
    dispatch(loadMotOptionsSuccess(reformatMotForOptionsMenu(response.data.Data)));
  }).catch((err) => {
    dispatch(loadMotFail(err));
    toastrError(err);
  });
};
